/**
 * Decide when to ask for product feedback after a successful download.
 * Submitted once, or dismissed with a 30-day cooldown.
 */

export const FEEDBACK_AFTER_DOWNLOAD_KEY = 'clarcv_feedback_after_download';
export const FEEDBACK_DISMISS_MS = 30 * 24 * 60 * 60 * 1000;
export const FEEDBACK_AFTER_DOWNLOAD_DELAY_MS = 4500;

const SUBMITTED = 'submitted';

const readValue = () => {
  try {
    return window.localStorage.getItem(FEEDBACK_AFTER_DOWNLOAD_KEY);
  } catch {
    return null;
  }
};

const writeValue = (value) => {
  try {
    window.localStorage.setItem(FEEDBACK_AFTER_DOWNLOAD_KEY, value);
  } catch {
    // Private mode / quota — skip persistence.
  }
};

/**
 * True when this browser already sent in-app feedback.
 *
 * @returns {boolean}
 */
export function hasSubmittedFeedback() {
  return readValue() === SUBMITTED;
}

/**
 * True when a post-download feedback prompt should open.
 *
 * @returns {boolean}
 */
export function shouldPromptAfterDownload() {
  const value = readValue();
  if (!value) {
    return true;
  }
  if (value === SUBMITTED) {
    return false;
  }
  const dismissedAt = Number(value);
  if (!Number.isFinite(dismissedAt)) {
    return true;
  }
  return Date.now() - dismissedAt >= FEEDBACK_DISMISS_MS;
}

/**
 * Remember that the visitor closed the prompt without sending.
 *
 * @returns {void}
 */
export function markFeedbackDismissed() {
  if (hasSubmittedFeedback()) {
    return;
  }
  writeValue(String(Date.now()));
}

/**
 * Remember that feedback was sent so we do not ask again.
 *
 * @returns {void}
 */
export function markFeedbackSubmitted() {
  writeValue(SUBMITTED);
}
